export default __webpack_public_path__ + "static/media/desk-paper.07a4b8d9.jpg";